import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShow3", component(opts));
  editor.BlockManager.add("slideShow3", block(opts));
};